var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "url(#gift-wallet_svg__a)",
  rx: 8
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#161639",
  d: "M28.25 14.75h-3.281a3 3 0 0 0-4.435-4.022 2.7 2.7 0 0 0-.534.769 2.7 2.7 0 0 0-.534-.769 3 3 0 0 0-4.435 4.022H11.75a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5m-6.656-2.962a1.499 1.499 0 0 1 2.475 1.632 1.5 1.5 0 0 1-.357.486c-.459.47-1.8.722-2.934.816.094-1.134.347-2.475.816-2.934m-5.306 0a1.51 1.51 0 0 1 2.118 0c.469.459.722 1.8.816 2.934-1.135-.094-2.475-.347-2.934-.816a1.51 1.51 0 0 1 0-2.118M28.25 19.25h-7.5V26a.75.75 0 1 1-1.5 0v-6.75h-7.5v-3h7.5v3h1.5v-3h7.5z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "gift-wallet_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 40 -19.8319 0 19.832 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCA31E"
})))));
export default SvgGiftWallet;